import type { ModalInternalProps } from '@sds-system/components';

export const modalDefaultProps: ModalInternalProps = {
  styledComponents: {
    root: {
      maxHeight: ['80%', '600px'],
      minHeight: ['0px'],
      maxWidth: ['calc(100% - 16px - 16px)', '1000px'],
      minWidth: ['320px', '424px'],
      padding: '24px',
      borderRadius: '8px',
    },
  },
};
